













import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
import SimpleLookup from '@/components/Cartable/EnterpriseForm/SimpleLookup/SimpleLookup.vue';
import { ValidValues } from '../../../../store/models/EnterpriseForm/EnterpriseFormValidValues';

@Component({
    components:{SimpleLookup}
})
export default  class  CustomQueryListBookmark extends Mixins(BookmarkMixin){
   
    valueProp = "";
    @Prop() validValues?: ValidValues;
    // get defaultValue(){
    //     if(this.tableColumnBookmark)
    //         return this.tableColumnBookmark.defaultValue;
    //     return '';
    // }
    created(){
        const data = {} as any;
        data.Id = '';
        data.Value = '';
        if(this.tableColumnBookmark && this.tableColumnBookmark.defaultValue){
            data.Id = this.tableColumnBookmark.defaultValue;
            data.Value = this.tableColumnBookmark.defaultValue;
        }
        else if(this.bookmark && this.bookmark.defaultValue)
        {
            data.Id = this.bookmark.defaultValue;
            data.Value = this.bookmark.defaultValue;
        }
        this.value = data;
    }
    onValueSelected(value: ValidValues){
        this.value.Id = value.item1;
        this.value.Value = value.item2;
        this.$emit("value-changed",this.englishName);
    }
    onValueChanged(){
        
        if(this.englishName.toLowerCase() === "kindofactivity"){
            const test = 1;
        }
        if(this.value)
            if(this.value.Value)
                this.valueProp = this.value.Value;
            else
                this.valueProp = this.value;
    }
    
}
